import React, { useEffect, useRef } from "react";
import { Button, Stack } from "@mui/material";
import { FaInfoCircle, FaUserPlus } from "react-icons/fa";



import SolutionComponent from "./SolutionComponent";
import { useLocation } from "react-router-dom";
import Header from "../../../Header/Header";
import Footer from "../../../Footer/Footer";
import CertificateCard from "../../CertificateCard/CertificateCard";

const FourthSectionPage = () => {
  const location = useLocation();
  const index = location.state?.index;

  return (
    <>
      <Header />
      <main>
        <SolutionComponent index={index}/>
        <CertificateCard />
      </main>
      <Footer />{" "}
    </>
  );
};

export default FourthSectionPage;
